import Dashboard from "views/Dashboard.js"
import Briefing from "views/Briefing.js"
import DriverReservations from "views/DriverReservations"
import UserProfile from "views/UserProfile.js"
import TableList from "views/TableList.js"
import Typography from "views/Typography.js"
import Icons from "views/Icons.js"
import Maps from "views/Maps.js"
import Upgrade from "views/Upgrade.js"
import Reports from "views/Reports.js"
import Orders from "views/Orders.js"
import Buses from "views/Buses.js"
import OldOrders from "views/OldOrders.js"
import Warehouse from "views/Warehouse.js"

import Tools from "views/tools/Tools.js"
import InvoiceToExcel from "views/tools/InvoiceToExcel.js"
import Signature from "views/tools/Signature.js"
import InvoiceToP44 from "views/tools/InvoiceToP44.js"
import EDI from "views/tools/EDI.js"
import BonusMain from "views/tools/bonus/BonusMain.js"
import BonusOrgChart from "views/tools/bonus/BonusOrgChart.js"
import BonusResult from "views/tools/bonus/BonusResult.js"
import PricePredictor from "views/tools/PricePredictor"
import Aging from "views/tools/aging/Aging"
import GrossMarginTable from "views/tools/grossmargin/GrossMarginTable"
import LoadLifeCycle from "views/tools/load-life-cycle/LoadLifeCycle"
import BusUtilization from "views/tools/busutilization/BusUtilization"

import AutomationMain from "views/tools/automation/AutomationMain"
import KPIs from "views/KPIs"
import { PulseMainView } from "views/pulse"
import { LogsMainView } from "./views/logs"

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/briefing",
    name: "Briefing",
    icon: "nc-icon nc-notes",
    component: Briefing,
    layout: "/admin",
  },
  {
    path: "/orders",
    name: "All Orders",
    icon: "nc-icon nc-delivery-fast",
    component: Orders,
    layout: "/admin",
  },
  {
    path: "/buses",
    name: "Buses",
    icon: "nc-icon nc-bus-front-12",
    component: Buses,
    layout: "/admin",
  },
  {
    path: "/warehouse",
    name: "Warehouse",
    icon: "nc-icon nc-app",
    component: Warehouse,
    layout: "/admin",
  },
  {
    path: "/KPIs",
    name: "KPIs",
    icon: "nc-icon nc-chart-pie-36",
    component: KPIs,
    layout: "/admin",
  },
  {
    path: "/Pulse",
    name: "Pulse",
    // icon: "nc-icon nc-bulb-63",
    icon: "nc-icon nc-chart-bar-32",
    component: PulseMainView,
    layout: "/admin",
  },
  {
    path: "/maps",
    name: "Maps",
    icon: "nc-icon nc-compass-05",
    component: Maps,
    layout: "/admin",
    hide: true
  },
  {
    path: "/driver-reservations",
    name: "Drivers",
    icon: "nc-icon nc-single-02",
    component: DriverReservations,
    layout: "/admin",
  },
  // {
  //   path: "/old_orders",
  //   name: "Old Orders",
  //   icon: "nc-icon nc-align-center",
  //   component: OldOrders,
  //   layout: "/admin",
  // },
  {
    path: "/logs",
    name: "Logs",
    icon: "nc-icon nc-align-left-2",
    component: LogsMainView,
    layout: "/admin",
  },
  {
    path: "/tools",
    name: "Tools",
    icon: "nc-icon nc-grid-45",
    component: Tools,
    layout: "/admin",
  },
  {
    path: "/app/invoice-to-excel",
    name: "Invoice to Excel",
    icon: "",
    component: InvoiceToExcel,
    layout: "/admin",
    hide: true,
  },
  {
    path: "/app/signature-generator",
    name: "Signature Generator",
    icon: "",
    component: Signature,
    layout: "/admin",
    hide: true,
  },
  {
    path: "/app/invoice-to-p44",
    name: "Invoice to P44",
    icon: "",
    component: InvoiceToP44,
    layout: "/admin",
    hide: true,
  },
  {
    path: "/app/edi",
    name: "EDI Integrations Manager",
    icon: "",
    component: EDI,
    layout: "/admin",
    hide: true,
  },
  //Bonus Calculator views
  {
    path: "/app/bonus",
    name: "Bonus Calculator",
    icon: "",
    component: BonusMain,
    layout: "/admin",
    hide: true,
  },
  {
    path: "/app/bonus-org-chart/:id",
    name: "Bonus Calculator",
    icon: "",
    component: BonusOrgChart,
    layout: "/admin",
    hide: true,
  },
  {
    path: "/app/bonus-manage/:id",
    name: "Bonus Calculator",
    icon: "",
    component: BonusResult,
    layout: "/admin",
    hide: true,
  },

  //Automations
  {
    path: "/app/automations",
    name: "Automations",
    icon: "",
    component: AutomationMain,
    layout: "/admin",
    hide: true,
  },

  // pricing mode
  {
    path: "/app/price-predictor",
    name: "Price Predictor",
    icon: "",
    component: PricePredictor,
    layout: "/admin",
    hide: true,
  },
  // Aging report
  {
    path: "/app/aging",
    name: "Aging Report",
    icon: "",
    component: Aging,
    layout: "/admin",
    hide: true,
  },
  // Gross Margin Table
  {
    path: "/app/grossmargin_table",
    name: "Gross Margin Table",
    icon: "",
    component: GrossMarginTable,
    layout: "/admin",
    hide: true,
  },
  // Load life cycle
  {
    path: "/app/load-life-cycle",
    name: "Load's life cycle",
    icon: "",
    component: LoadLifeCycle,
    layout: "/admin",
    hide: true,
  },
  // Bus utilization report
  {
    path: "/app/bus-utilization",
    name: "Bus Utilization",
    icon: "",
    component: BusUtilization,
    layout: "/admin",
    hide: true,
  },
  // Settings views
  {
    path: "/settings",
    name: "Settings",
    icon: "nc-icon nc-preferences-circle-rotate",
    component: UserProfile,
    layout: "/admin",
  },
]

export default dashboardRoutes
